const formatBalance = (balance: string) => {
  const formattedString = Number(balance).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).replace(',', '.');

  return formattedString;
}; 

export default formatBalance;
